module.exports = __webpack_public_path__ + "static/media/blog-40-3.1887dfd1.webp";